import { useContext } from "react";
import {  ConfiguratorContext, initialContext } from "../context";

const useFinanciadoData = () => {

  const [state, setState] = useContext(ConfiguratorContext);

  //Getters
  const getFinanciado = () => state.financiado ? state.financiado : null;
  const getIgnoreFinanciado = () => state.financiado.ignore ? state.financiado.ignore : true;
  const getPreApproved = () => state.financiado.pre_approved;
  const getSimulationChanged = () => state.financiado.simulation_changed;
  const getSimulateNumberFees = () => state.simulated_data.simulate_number_fees;
  const getSimulateDownpaymentPercentage = () => state.simulated_data.simulate_downpayment_percentage;
  const getSimulatedCreditData = () => state.simulated_data.simulated_credit_data;
  const getUsado = () => state.usado ? state.usado : null;
  const getPreApprovalData = () => state.preapproval_data ? state.preapproval_data : null;

  //Setters

  const setFinanciado = financiado => {
    setState(prevState => ({
      ...prevState,
      financiado: {
        ...prevState.financiado,
        ...financiado,
      }
    }))
  }

  const setUsado = (patent, details, selectedVersion, mileage, range, checkedMaintenance) => {
    setState(prevState => ({
      ...prevState,
      usado: {
        patent,
        details,
        selectedVersion,
        mileage,
        range,
        checkedMaintenance
      }
    }))
  }

  const resetUsado = () => {
    setState(prevState => ({
      ...prevState,
      usado: initialContext.usado
    }))
  }

  const setSimulateNumberFees = numberFees => {
    setState(prevState => ({
      ...prevState,
      simulated_data: {
        ...prevState.simulated_data,
        simulate_number_fees: numberFees
      }
    }))
  }
  
  const setSimulateDownpaymentPercentage = downpaymentPercentage => {
    setState(prevState => ({
      ...prevState,
      simulated_data: {
        ...prevState.simulated_data,
        simulate_downpayment_percentage: downpaymentPercentage
      }
    }))
  }

  const setIgnoreFinanciado = ignore => {
    setState(prevState => ({
      ...prevState,
      financiado: {
        ...prevState.financiado,
        ignore: {value: ignore}
      }
    }))
  }

  const setPreApproved = pre_approved => {
    setState(prevState => ({
      ...prevState,
      financiado: {
        ...prevState.financiado,
        pre_approved
      }
    }));
  }


  const setSimulationChanged = simulation_changed => {
    setState(prevState => ({
      ...prevState,
      financiado: {
        ...prevState.financiado,
        simulation_changed
      }
    }));
  }


  const resetFinanciado = () => {
    setState(prevState => ({
      ...prevState,
      financiado: initialContext.financiado
    }))
  }

  const setSimulatedCreditData = (simulated_credit_data) => {
    setState(prevState => ({
      ...prevState,
      simulated_data:{
        ...prevState.simulated_data,
        simulated_credit_data: simulated_credit_data
      }
    }))
  }

  const setPreapprovalData = (simulated_data) => {
    setState(prevState => ({
      ...prevState,
      preapproval_data:{
        ...prevState.preapproval_data,
        simulated_data: simulated_data
      }
    }))
  }

  //Methods

  return {
    getFinanciado,
    getIgnoreFinanciado,
    setFinanciado,
    setIgnoreFinanciado,
    setPreApproved,
    getPreApproved,
    getSimulateNumberFees,
    getSimulateDownpaymentPercentage,
    setSimulateNumberFees,
    setSimulateDownpaymentPercentage,
    resetFinanciado,
    getSimulationChanged,
    setSimulationChanged,
    getSimulatedCreditData,
    setSimulatedCreditData,
    getUsado,
    setUsado,
    resetUsado,
    getPreApprovalData,
    setPreapprovalData
  }

}


export default useFinanciadoData;
